import { render, staticRenderFns } from "./UserLearningHistoryPage.vue?vue&type=template&id=432976f8&scoped=true"
import script from "./UserLearningHistoryPage.vue?vue&type=script&lang=js"
export * from "./UserLearningHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./UserLearningHistoryPage.vue?vue&type=style&index=0&id=432976f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432976f8",
  null
  
)

export default component.exports